import { createAction } from '@reduxjs/toolkit';
import {
  ACTUALIZE_PACKAGE,
  ACTUALIZE_PACKAGE_SUCCESS,
  ACTUALIZE_PACKAGE_FAIL,
  SHOW_PRICE_CHANGED,
  HIDE_PRICE_CHANGED,
  START_ACTUALIZE_PACKAGE,
  STOP_ACTUALIZE_PACKAGE,
  SET_FRONT_ERROR,
} from '../constants/actualization';

export const actualizePackageAction = createAction<{ force: true } | undefined>(
  ACTUALIZE_PACKAGE,
);

export const actualizePackageSuccess = (payload) => ({
  type: ACTUALIZE_PACKAGE_SUCCESS,
  payload,
});

export const actualizePackageFail = (payload) => ({
  type: ACTUALIZE_PACKAGE_FAIL,
  payload,
});

export const showPriceChanged = () => ({
  type: SHOW_PRICE_CHANGED,
});

export const hidePriceChanged = () => ({
  type: HIDE_PRICE_CHANGED,
});

export const startActualizationProcessAction = () => ({
  type: START_ACTUALIZE_PACKAGE,
});

export const stopActualizationProcessAction = () => ({
  type: STOP_ACTUALIZE_PACKAGE,
});

export const setFrontErrorAction = createAction<
  'actualize_error' | 'network_error' | 'data_parsing_error'
>(SET_FRONT_ERROR);
